import { PayloadAction } from '../../../store.model';
import { makeRows as makeFocusSelectionRows } from '../focus-selection/focus-selection.function';
import { ActionType } from '../focus-selector.action';
import { FocusSelectorState } from '../focus-selector.state';
import { setupLoadGoalsState } from '../load-goals/load-goals.function';
import { makeRows as makeMetricSelectionRows } from '../metric-selection/metric-selection.function';
import { FocusSelectorMetricModel } from '../model/focus-selector-metric.model';

import {
    FocusSelectorSelectActiveMetric,
    FocusSelectorSelectMetricRow,
} from './metric-selection.action';

export function focusSelectorSelectActiveMetricReducer(
    state: FocusSelectorState,
    action: PayloadAction<ActionType, FocusSelectorSelectActiveMetric>,
): FocusSelectorState {
    let activeMetric: FocusSelectorMetricModel = { id: null, name: '' };

    const foundActiveMetric = state.coachableMetrics.find(
        (metric) => metric.id === action.payload.activeMetricId,
    );

    if (foundActiveMetric != null) {
        activeMetric = foundActiveMetric;
    }

    const updatedMetricRows = makeMetricSelectionRows(
        state.coachableMetrics,
        activeMetric,
    );

    const updatedFocusSelectionRows = makeFocusSelectionRows(
        state.behaviours,
        activeMetric.id,
        state.selectedFocus?.subBehaviour?.id,
    );

    const { goals, loadGoalsGrid, selectedGoals, updatedGoalsCollection } =
        setupLoadGoalsState(
            activeMetric,
            state.selectedFocus,
            state.coachableMetrics,
            state.behaviours,
            state.initSelectedMetricIds,
            state.goalsCollection,
            state.loadGoalsGrid,
        );

    return {
        ...state,
        activeMetric,

        goals,
        selectedGoals,
        goalsCollection: updatedGoalsCollection,

        metricSelectionGrid: {
            ...state.metricSelectionGrid,
            rows: updatedMetricRows,
            sortDefs: [...state.metricSelectionGrid.sortDefs],
        },

        focusSelectionGrid: {
            ...state.focusSelectionGrid,
            rows: updatedFocusSelectionRows,
            sortDefs: [...state.focusSelectionGrid.defaultSortDefs],
            filterByBehaviourId: null,
            selection: {
                behaviourId: state.selectedFocus?.behaviour?.id ?? null,
                subBehaviourId: state.selectedFocus?.subBehaviour?.id ?? null,
            },
        },

        loadGoalsGrid,
    };
}

export function focusSelectorSelectMetricRowReducer(
    state: FocusSelectorState,
    action: PayloadAction<ActionType, FocusSelectorSelectMetricRow>,
): FocusSelectorState {
    const selectedMetric = state.coachableMetrics.find(
        (metric) => metric.id === action.payload.metricRowId,
    );

    const updatedMetricRows = makeMetricSelectionRows(
        state.coachableMetrics,
        selectedMetric,
    );

    return {
        ...state,
        metricSelectionGrid: {
            ...state.metricSelectionGrid,
            rows: updatedMetricRows,
            sortDefs: [...state.metricSelectionGrid.sortDefs],
        },
    };
}
